export const PHONE_PATTERN = /^(?:\+33\s?|0)\d{1,2}(?:\s?\d{2}){4}$/;
export const SIRET_PATTERN = /^\d{14}$/;
export const WEBSITE_PATTERN =
  /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
